import { Node, nodeInputRule } from "@tiptap/core";

export const createSmartValueExtension = (getDefinition, onActivate) =>
  Node.create({
    name: "smartValue",
    group: "inline",
    inline: true,
    atom: true,
    selectable: true,
    addAttributes() {
      return {
        variableKey: {
          default: "",
          parseHTML: (element) => element.getAttribute("data-smart-value"),
        },
      };
    },
    parseHTML() {
      return [{ tag: "span[data-smart-value]" }];
    },
    renderHTML({ node }) {
      return [
        "span",
        { "data-smart-value": node.attrs.variableKey },
        `{{${node.attrs.variableKey}}}`,
      ];
    },
    renderText({ node }) {
      return `{{${node.attrs.variableKey}}}`;
    },
    addInputRules() {
      return [
        nodeInputRule({
          find: /(?<!\\)\{\{([a-z][a-z0-9_]{0,59})\}\}$/,
          type: this.type,
          getAttributes: (match) => ({ variableKey: match[1] }),
        }),
      ];
    },
    addNodeView() {
      return ({ node, getPos, editor }) => {
        const button = document.createElement("button");
        button.type = "button";
        button.contentEditable = "false";
        button.dataset.smartValue = node.attrs.variableKey;
        const refresh = () => {
          const variable = getDefinition(node.attrs.variableKey);
          button.textContent = variable?.label || node.attrs.variableKey;
          button.setAttribute(
            "aria-label",
            `Editar variável ${variable?.label || node.attrs.variableKey}`
          );
        };
        refresh();
        const activate = () => {
          const position = getPos();
          if (typeof position !== "number" || !editor.isEditable) return;
          editor.commands.setNodeSelection(position);
          onActivate(node.attrs.variableKey, position);
        };
        button.addEventListener("click", activate);
        return {
          dom: button,
          stopEvent: (event) =>
            event.type === "click" ||
            (event.type === "keydown" && ["Enter", " "].includes(event.key)),
          destroy: () => button.removeEventListener("click", activate),
        };
      };
    },
  });
